import { lazy, Suspense, useState } from "react";
import { Link } from "react-router-dom";
import useLocalStorage from "use-local-storage";

const AuthDialogs = lazy(() => import("./AuthDialogs"));

export default function LoginRegisterButton() {
  const [userProfile, setUserProfile] = useLocalStorage("userProfile");
  const [modalLogin, setModalLogin] = useState(false);
  const [modalProfile, setModalProfile] = useState(false);
  const [modalChangePassword, setModalChangePassword] = useState(false);
  const [modalTerms, setModalTerms] = useState(false);
  const [modalPrivacy, setModalPrivacy] = useState(false);

  const toggleLogin = () => setModalLogin(!modalLogin);
  const toggleProfile = () => setModalProfile(!modalProfile);
  const toggleChangePassword = () => setModalChangePassword(!modalChangePassword);
  const toggleTerms = () => setModalTerms(!modalTerms);
  const togglePrivacy = () => setModalPrivacy(!modalPrivacy);

  const anyOpen = modalLogin || modalProfile || modalChangePassword || modalTerms || modalPrivacy;

  const initials = userProfile
    ? `${(userProfile.firstName || '')[0] || ''}${(userProfile.lastName || '')[0] || ''}`.toUpperCase()
    : '';

  return (
    <>
      {
        userProfile ?
          <Link to="#" onClick={toggleProfile} style={{ textDecoration: 'none' }}>
            <span className="f-btn f-btn-ghost" style={{ padding: '8px 16px', fontSize: '0.85rem', gap: 10 }}>
              <span
                aria-hidden
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, var(--f-clay) 0%, var(--f-rust) 100%)',
                  color: 'var(--f-cream)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: "'Cormorant Garamond', serif",
                  fontStyle: 'italic',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                }}
              >{initials}</span>
              {userProfile.firstName}
            </span>
          </Link>
          : <Link to="#" onClick={toggleLogin} style={{ textDecoration: 'none' }}>
            <span className="f-btn f-btn-clay" style={{ padding: '10px 20px', fontSize: '0.85rem' }}>
              Sign in
            </span>
          </Link>
      }

      {anyOpen && (
        <Suspense fallback={null}>
          <AuthDialogs
            modalLogin={modalLogin}
            toggleLogin={toggleLogin}
            modalProfile={modalProfile}
            toggleProfile={toggleProfile}
            modalChangePassword={modalChangePassword}
            toggleChangePassword={toggleChangePassword}
            modalTerms={modalTerms}
            toggleTerms={toggleTerms}
            modalPrivacy={modalPrivacy}
            togglePrivacy={togglePrivacy}
          />
        </Suspense>
      )}
    </>
  );
}
